import { useEffect, useState } from "react";

import Select from 'react-select';

import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

import projectStatuses from '../data/projectStatuses.json';

const ProjectForm = ({ project, onSubmit }) => {
  const [name, setName] = useState(project?.title || '');
  const [address, setAddress] = useState(project?.siteAddress || '');

  const [startDate, setStartDate] = useState(formatDateToSydneyTimeZone(project?.startDate, 'yyyy-MM-dd') || '');
  const [endDate, setEndDate] = useState(formatDateToSydneyTimeZone(project?.endDate, 'yyyy-MM-dd') || '');

  const [status, setStatus] = useState(project?.status || 'Active');

  useEffect(() => {
    setName(project?.name || '');
    setAddress(project?.address || '');
    setStartDate(formatDateToSydneyTimeZone(project?.startDate, 'yyyy-MM-dd') || '');
    setEndDate(formatDateToSydneyTimeZone(project?.endDate, 'yyyy-MM-dd') || '');
    setStatus({ label: project?.status, value: project?.status });
  }, [project])

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit({
      name,
      address,
      startDate,
      endDate,
      status: status.value
    });
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 w-full"
    >
      <label className="flex flex-col gap-1 w-full">
        Name
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </label>

      <label className="flex flex-col gap-1 w-full">
        Status

        <Select
          value={status}
          options={projectStatuses}
          onChange={setStatus}
        />
      </label>

      <label className="flex flex-col gap-1 w-full">
        Address
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </label>

      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <label className="flex flex-col gap-1 w-full">
          Start Date
          <input
            className="w-full md:w-auto"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>

        <label className="flex flex-col gap-1 w-full">
          End Date
          <input
            className="w-full md:w-auto"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div>

      <button
        type="submit"
        className="ase-button-primary h-[48px]"
      >
        Submit
      </button>
    </form>
  )
}

export default ProjectForm;
